import React from 'react';
import { motion } from 'framer-motion';
import { EASING, useReducedMotion } from '../hooks/useMotion';

/**
 * Apple-style page transition — subtle blur + lift on enter/exit.
 * Honors prefers-reduced-motion.
 */
const PageTransition = ({ children }) => {
  const reduced = useReducedMotion();
  if (reduced) return <>{children}</>;
  return (
    <motion.div
      initial={{ opacity: 0, y: 16, filter: 'blur(8px)' }}
      animate={{ opacity: 1, y: 0, filter: 'blur(0px)' }}
      exit={{ opacity: 0, y: -12, filter: 'blur(6px)' }}
      transition={{ duration: 0.45, ease: EASING.appleSmooth }}
      style={{ willChange: 'transform, opacity, filter' }}
    >
      {children}
    </motion.div>
  );
};

export default PageTransition;
